import { render, staticRenderFns } from "./estado.vue?vue&type=template&id=e64a5920&scoped=true"
import script from "./estado.vue?vue&type=script&lang=js"
export * from "./estado.vue?vue&type=script&lang=js"
import style0 from "./estado.vue?vue&type=style&index=0&id=e64a5920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64a5920",
  null
  
)

export default component.exports